import { render, staticRenderFns } from "./AutoRun.vue?vue&type=template&id=7c24db40&"
import script from "./AutoRun.vue?vue&type=script&lang=js&"
export * from "./AutoRun.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports